(function () {
  var TARGET_SELECTOR = '.title:not(.text-reveal-done), .tribe-lore-page__title:not(.text-reveal-done), .tribes-hub__intro h3:not(.text-reveal-done), .collection-hero__title:not(.text-reveal-done)';

  function wrapWords(node, counterRef) {
    Array.from(node.childNodes).forEach(function (child) {
      if (child.nodeType === Node.TEXT_NODE) {
        var text = child.textContent;
        if (!text.trim()) return;
        var parts = text.split(/(\s+)/).filter(function (p) { return p.length > 0; });
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            var wrap = document.createElement('span');
            wrap.className = 'text-reveal__word';
            var inner = document.createElement('span');
            inner.className = 'text-reveal__word-inner';
            inner.style.setProperty('--word-index', counterRef.i++);
            inner.textContent = part;
            wrap.appendChild(inner);
            frag.appendChild(wrap);
          }
        });
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        wrapWords(child, counterRef);
      }
    });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var targets = Array.from(document.querySelectorAll(TARGET_SELECTOR));
    if (!targets.length) return;

    targets.forEach(function (el) {
      el.classList.add('text-reveal-done');
      wrapWords(el, { i: 0 });
    });

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('text-reveal--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
